// GENERATED FROM 'messages.json' (via yarn run messages:generate)
// !! DO NOT CHANGE MANUALLY !!

import { type ReactElement } from "react";

import { FormattedMessage } from "react-intl";

export const ModalHeader = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.shared.deleteLens.modalHeader"
        description="Modal header."
        defaultMessage="Delete Lens?"
    />
);
ModalHeader.displayName = "ModalHeader";

export const ModalText = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.shared.deleteLens.modalText"
        description="Modal text."
        defaultMessage="Deletion will remove the Lens from your account and from Snapchat. This cannot be undone."
    />
);
ModalText.displayName = "ModalText";

export const ModalActionCancel = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.shared.deleteLens.modalActionCancel"
        description="Modal action cancel."
        defaultMessage="Cancel"
    />
);
ModalActionCancel.displayName = "ModalActionCancel";

export const ModalActionDelete = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.shared.deleteLens.modalActionDelete"
        description="Modal action delete."
        defaultMessage="Delete"
    />
);
ModalActionDelete.displayName = "ModalActionDelete";

export const LensCreatorPayoutAlertTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.shared.deleteLens.lensCreatorPayoutAlertTitle"
        description="Lens creator payout alert title."
        defaultMessage="Warning!"
    />
);
LensCreatorPayoutAlertTitle.displayName = "LensCreatorPayoutAlertTitle";

export const LensCreatorPayoutAlertDescription = (): ReactElement => (
    <FormattedMessage
        id="apps.lens.components.shared.deleteLens.lensCreatorPayoutAlertDescription"
        description="Lens creator payout alert description."
        defaultMessage="Please note: If you delete this Lens, it will be removed from the Top Performer Payouts Program and you will not be eligible to receive a payout for any accrued engagement."
    />
);
LensCreatorPayoutAlertDescription.displayName = "LensCreatorPayoutAlertDescription";
